// @ts-nocheck
import React from "react";
import useAccount from "classes/Accounts/hooks/useAccount";
import { useQuery } from "react-query";
import genRequest from "includes/request";
import InfosFetcher from "components/InfosFetcher/InfosFetcher";
import "./FormTiles.css";
import formatDate from "includes/formatDate";
import { t } from "i18next";

export default function FormsTiles({ onClick, showDrafts }) {
	const { account, isAdmin } = useAccount();
	const { isLoading, data } = useQuery(
		["Forms", "FormAffectedToCompany", account.companyId],
		() => genRequest("forms/company/" + account.companyId)
	);

	if (isLoading)
		return (
			<div className="FormTile tile loading">
				<div className="w-100"></div>
				<div className="w-75"></div>
				<div className="w-50"></div>
			</div>
		);

	if (!data?.length) return <div>{t('Forms.NO_FORM')}</div>;

	let date = formatDate();

	return (
		<div className="tiles-cont">
			{data.map((a) => {
				if (showDrafts !== a.isDraft) return false;
				if (
					((!a.availableToDate || a.availableToDate >= date) &&
						a.publishedDate <= date) ||
					isAdmin()
				)
					return (
						<FormTile
							onClick={() => onClick(a)}
							key={a.id}
							form={a}
						/>
					);
				return false;
			})}
		</div>
	);
}

export function FormTile({ form, onClick, className }) {
	if (!form) return false;
	const formId = form.id || form.formId;

	return (
		<div
			className={"FormTile tile" + (className ? " " + className : "")}
			onClick={onClick}
		>
			<div>
				<div className="form-title font-bold">{form.title}</div>
				<div className="form-text">{form.txt}</div>
			</div>
			<div className="form-infos">
				{formId && <InfosFetcher
					queryKey={["FormQuestions", "QuestionOfForm", formId]}
					queryFn={() =>
						genRequest(
							"forms/" + formId + "/questions"
						)
					}
					treat={(infos) => {
						return t("Forms.QUESTIONS", { count: infos.length });
					}}
				/>}
			</div>
		</div>
	);
}
